<template>
  <div class="profile">
    <Header v-bind:msg="role" />
    <div class="container mt-5">
      <div class="avatar">
        <h1>Tài khoản</h1>
        <div>
          <p>Tên tài khoản</p>
          <input type="text" name="" id="" required v-model="name" />
        </div>
        <div>
          <p>Tên đăng nhập</p>
          <input type="text" name="" id="" required v-model="username" />
        </div>
        <div>
          <p>Mật khẩu</p>
          <input
            type="text"
            name=""
            id=""
            required
            v-model="password"
            disabled
          />
        </div>
        <div>
          <p>Số điện thoại</p>
          <input type="text" name="" id="" required v-model="phone" />
        </div>
        <div>
          <p>Facebook</p>
          <input type="text" name="" id="" required v-model="facebook" />
        </div>
        <div>
          <p>Địa chỉ</p>
          <input type="text" name="" id="" required v-model="address" />
        </div>
                <div>
          <p>Giới tính</p>
          <input type="text" name="" id="" required v-model="gender" />
        </div>
        <div>
          <button @click="saved()" class="btn btn-primary">Lưu</button>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import axios from "axios";
export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      role: sessionStorage.getItem("role"),
      name: sessionStorage.getItem("name"),
      username: sessionStorage.getItem("username"),
      password: sessionStorage.getItem("password"),
      facebook: sessionStorage.getItem("facebook"),
      phone: sessionStorage.getItem("phone"),
      address: sessionStorage.getItem("address"),
      id: sessionStorage.getItem("id"),
      gender: sessionStorage.getItem("gender"),
    };
  },
  methods: {
    saved() {
      if (
        this.name != "" &&
        this.username != "" &&
        this.password != "" &&
        this.phone != "" &&
        this.address != "" &&
        this.facebook != ""
      ) {
        axios
          .put(
            "https://sheet.best/api/sheets/98958532-8ddf-478a-b977-9f68a6bf7d7b/tabs/Accounts/id/" +
              this.id,
            {
              active: sessionStorage.getItem("active"),
              address: this.address,
              created: sessionStorage.getItem("created"),
              facebook: this.facebook,
              gender: this.gender,
              id: sessionStorage.getItem("id"),
              name: this.name,
              owned: sessionStorage.getItem("owned"),
              password: this.password,
              phone: this.phone,
              role: sessionStorage.getItem("role"),
              username: this.username
            }
          )
          .then(response => {
            // console.log(response.data);
            sessionStorage.setItem("id", this.id);
            sessionStorage.setItem("name", this.name);
            sessionStorage.setItem("username", this.username);
            sessionStorage.setItem("password", this.password);
            sessionStorage.setItem("gender", this.gender);
            sessionStorage.setItem("address", this.address);
            sessionStorage.setItem("phone", this.phone);
            sessionStorage.setItem("facebook", this.facebook);
            alert("Đã lưu thành công")

          });
      }
    }
  }
};
</script>

<style lang="css" scoped>
p {
  padding: 0;
  margin: 0;
  /* background:#444; */
  /* color:#fff; */
}
img {
  width: 4rem;
}
input {
  outline: none;
  padding: 0.5rem 1rem;
  border: none;
  background: whitesmoke;
  /* border-bottom: 2px solid #444; */
  border-radius: 0;
  margin-bottom: 1rem;
}
input:focus {
  background-color: #ccc;
}
button {
  width: 13.7rem;
  padding: 0.5rem 1rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue